import React, { useState, useEffect } from "react";
import { useLocation, Link } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Drawer, Box, useMediaQuery, useTheme } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';
import pic from "./pictures/frame-logo.png";
import SearchIcon from '@mui/icons-material/Search';
import Submenu from "./Submenu";
import SearchComponent from "./SearchComponent";
import DrawerMenu from "./MobileSubMenu";
import CustomButton from "./ReusableComponents/CustomButton";
import axios from "axios";
import { useSelector } from "react-redux";
import UserOptions from "./UserOptions";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Custom styles for the AppBar, Button, and logo
const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#ffffff',
    color: '#000000',
    width: '100%',
    height: '140px',
    borderBottom: '1px solid #F2F4F7',
    boxShadow: 'none',
    opacity: 1,
    fontFamily: 'Manrope',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      height: '61px',
      paddingLeft: '1px',
      paddingRight: '1px',
    },
  },
  toolbar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%', // Ensures the toolbar takes full height of AppBar
    padding: '60px 60px', // Add padding if needed
    [theme.breakpoints.down('sm')]: {
      padding: '30px 30px'
    }
  },
  drawer: {
    width: 250,
  },
  logo: {
    width: 'auto', // Logo width
    height: '100px', // Logo height
    gap: '0px', // No gap
    opacity: 1, // Fully opaque
    marginRight: theme.spacing(2), // Adjusted margin for better alignment
    [theme.breakpoints.down('sm')]: {
      width: '36px',
      height: '45px',
    },
  },
  buttonPrice: {
    backgroundColor: '#2A2A2A', // Custom background color
    width: '128px',
    height: '59px',
    gap: '8px',
    borderRadius: '80px',
    color: '#ffffff', // Text color
    opacity: 1,
    fontFamily: 'Manrope', // Font family
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '27px',
    textAlign: 'left',
    textTransform: 'none', // Ensure text is not transformed to uppercase
    textDecoration: 'none', // Remove underline from links
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '96px',
      height: '40px',
      fontWeight: 500,
      fontSize: '14px',
    },
  },
  menuItem: {
    color: '#737373', // Default text color
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'left',
    textTransform: 'none',
    marginRight: '32px',
    textDecoration: 'none',
    cursor: 'pointer',
    listStyleType: 'none',
    transition: 'color 0.3s ease', // Smooth transition for color change

    '&:hover': {
      color: 'green', // Hover color
    },
    '&.active': {
      color: 'red', // Active color
    },
  },

  selectedMenu: {
    color: 'green',
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'left',
    textTransform: 'none',
    marginRight: '32px',
    textDecoration: 'none',
    cursor: 'pointer',
  },

  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px', // Gap between menu items and buttons
  },
  mobileMenuContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end', // Align to the right
    width: '100%', // Take full width
    gap: '16px', // Gap between the donate button and menu icon
  },
}));

function Nav() {



  const location = useLocation();//for checking the rendering
  const { isAuthenticated, user } = useSelector(state => state.user);


  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeMenu, setActiveMenu] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);




  const [clickedMenuItem, setClickedMenuItem] = useState('Home');//for setting the active color to desktop meny

  const handleMenuColor = (menuName) => {
    setClickedMenuItem(menuName);
  }



  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };


  useEffect(() => {
    // Reset active menu whenever the route changes
    setActiveMenu(null);
    //reset search bar to close when route changes
    setDrawerOpen(false)
    setSearchOpen(false);
  }, [location]);



  const handleMouseLeave = () => {
    setActiveMenu(null); // Close the submenu
  };

  const handleMenuClick = (menuKey) => {
    setActiveMenu(activeMenu === menuKey ? null : menuKey);
    setClickedMenuItem(menuKey);
  };
  //on hover active menu 
  const handleMenuHover = (menuKey) => {
    setActiveMenu(activeMenu === menuKey ? null : menuKey);
    setClickedMenuItem(menuKey);
  };



  // controlling search bar from this function
  const handleSearchBar = () => {

    if (!searchOpen) {
      setActiveMenu(null);
      setSearchOpen(true);

    }
    else {
      setSearchOpen(false);
    }

  }


  // Utility: Transform backend response into submenuData structure
  const transformMenuTree = (menuTree) => {
    const submenu = {};

    menuTree.forEach(menu => {
      const key = menu.name?.toLowerCase().replace(/\s+/g, '') || 'unknown';

      submenu[key] = {
        title: menu.name || '',
        heading: menu.heading || '',
        link: menu.link || '',
        desc: menu.description || '',
        btnLink: menu.button_url || '',
        label: menu.button_label || '',
        links: (menu.items || []).map(item => {
          const hasImageBox = item.show_image_box === 'Y';

          if (hasImageBox && item.details?.length > 0) {
            const content = item.details[0];
            return {
              label: item.name,
              path: item.link,
              content: {
                heading: content.heading,
                detail: content.description,
                image: content.image_url,
                buttonText: content.button_label,  // ← add this
                buttonLink: content.button_url,    // ← add this

              }
            };
          } else {
            return {
              label: item.name,
              path: item.link,
              items: (item.details || []).map(detail => ({
                label: detail.name,
                path: detail.link
              }))
            };
          }
        }),
        image: menu.image || "https://via.placeholder.com/150"
      };
    });

    return submenu;
  };

  const [submenuData, setSubmenuData] = useState({});


  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/all/menus`); // Replace with your real URL
        console.log(response)
        const transformed = transformMenuTree(response.data);
        setSubmenuData(transformed);
      } catch (error) {
        console.error("Failed to fetch menu:", error);
      }
    };

    fetchMenu();
  }, []);


  return (
    <Box>
      <Box className="max-w-screen-2xl mx-auto">
        <AppBar position="static" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <Link to="/"><img src={pic} alt="pic" className={classes.logo} /></Link>

            {isMobile ? (
              <Box className={classes.mobileMenuContainer}>
                {isAuthenticated && <UserOptions user={user} />}
                <CustomButton btnURL="https://donate.akhuwat.org.pk/" btnText="Donate" className={classes.buttonPrice} />
                {(
                  <>
                    <IconButton edge="end" className={classes.menuButton} color="inherit" aria-label="menu" onClick={toggleDrawer(!drawerOpen)}>
                      <MenuIcon style={{ color: '#0F6742', width: '24.38px' }} />
                    </IconButton>

                    <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                      <DrawerMenu data={submenuData} closeDrawer={(toggleDrawer(false))} />
                    </Drawer>
                  </>
                )}



              </Box>
            ) : (
              <Box className={classes.menuContainer}

              >

                {isAuthenticated && <UserOptions user={user} />}
                {Object.entries(submenuData).map(([key, submenu]) => (
                  <li
                    key={key}
                    onClick={() => handleMenuClick(key)}
                    onMouseEnter={() => handleMenuHover(key)}
                    className="list-none"
                  >
                    <Link to={submenu.link}>
                      <span
                        className={`${clickedMenuItem === key
                          ? 'text-topGreen border-b pb-[10px] border-b-[3px] border-topGreen'
                          : 'text-SlateGray'
                          } font-semibold font-manrope text-[16px] text-left leading-[24px]
              cursor-pointer mr-8 hover:text-topGreen`}
                      >
                        {submenu.title}
                      </span>
                    </Link>
                  </li>
                ))}



                <div onClick={() => handleSearchBar()} className={classes.menuItem}><SearchIcon /></div>
                <CustomButton btnURL="https://donate.akhuwat.org.pk/" className={classes.buttonPrice} btnText="Donate" />

              </Box>
            )}
          </Toolbar>
        </AppBar>

        {/* Render Submenu based on active menu item */}
        <Box
          onMouseLeave={handleMouseLeave}
        >


          <Submenu
            title={submenuData[activeMenu]?.heading}
            links={submenuData[activeMenu]?.links || []}
            image={submenuData[activeMenu]?.image}
            isVisible={!!activeMenu}
            desc={submenuData[activeMenu]?.desc}
            btnLink={submenuData[activeMenu]?.btnLink}
            btnLabel={submenuData[activeMenu]?.label}
          />
        </Box>


      </Box>


      {/* render search bar if butotn clicked */}
      {searchOpen ? (
        <Box className="lg:block hidden">

          <SearchComponent closeSearchBar={handleSearchBar} />
        </Box>
      ) : (<Box></Box>)}
    </Box>
  );
}

export default Nav;
